<div *ngIf="isAuthenticating$ | async" class="recover_spinner">
	<ahp-spinner></ahp-spinner>
</div>
<gap-card>
	<gap-card-title data-cy="recover__card--title">{{ 'recover.header' | locale }}</gap-card-title>
	<gap-card-subtitle data-cy="recover__card--subtitle">{{ 'recover.subheader' | locale }}</gap-card-subtitle>
	<gap-card-content [innerHTML]="'recover.instructions' | locale: null:true"></gap-card-content>
	<gap-card-content>
		<ahp-dynamic-form
			[controls]="recoverFormControls"
			[formSubmitted]="recoverLoginSubmitted"
			[enhancedPhoneNumber]="enhancedPhoneNumber"
			(formValidityChange)="recoverLoginFormChanged($event)"
			style="z-index: 1; position: relative"
			#recoverForm
		></ahp-dynamic-form>
	</gap-card-content>
	<gap-card-actions class="button--no-margin card-actions">
		<gap-button
			data-cy="recover__button--submitRecoverLogin"
			gap-color="secondary"
			gap-type="raised"
			ahpAnalyticsClick='button|{"button_section":"recover","button_action":"submit"}'
			[disabled]="isAuthenticating$ | async"
			(click)="submitRecoverLogin()"
		>
			<ng-container *ngIf="isAuthenticating$ | async; else normalText">
				{{ 'common.authenticating' | locale }}
			</ng-container>
			<ng-template #normalText>
				{{ 'recover.submit' | locale }}
			</ng-template>
		</gap-button>
		<gap-button
			data-cy="recover__button--backToLogin"
			gap-color="secondary"
			gap-type="outlined"
			ahpAnalyticsClick='button|{"button_section":"recover","button_action":"back to login"}'
			ahpRouteTo="login"
			[disabled]="isAuthenticating$ | async"
		>
			{{ 'recover.login' | locale }}
		</gap-button>
	</gap-card-actions>
</gap-card>
